export default __webpack_public_path__ + "static/media/slide3.ba318bfa.jpg";